angular.module("vgresiduos").factory("disposalService", [
	"$http",
	"$q",
	"$rootScope",
	"localStorageWithTimeoutService",
	"accountService",
	function ($http, $q, $rootScope, localStorageWithTimeoutService, accountService) {
		"use strict";

		const disposalTypesCacheKey = Vgr.constants.cacheKeysPrefix.disposalTypes;
		const cacheTimeoutInMinutes = 43200;

		// disposal disposal

		const _getDisposal = function (id) {
			const req = {
				method: "get",
				url: Vgr.constants.newHostUrl + Vgr.resources.apiV1.disposals + id
			};
			return $http(req);
		};

		const _createDisposal = function (model) {
			const deferred = $q.defer();

			const req = {
				method: "post",
				data: model,
				url: Vgr.constants.newHostUrl + Vgr.resources.apiV1.disposals
			};

			$http(req).then(
				function (data) {
					deferred.resolve(data);
				},
				function (data) {
					deferred.reject(data);
				}
			);

			return deferred.promise;
		};

		const _updateDisposal = function (dto) {
			const req = {
				method: "put",
				data: dto.model,
				url: Vgr.constants.newHostUrl + Vgr.resources.apiV1.disposals + dto.disposalId
			};
			return $http(req);
		};

		const _listDisposalNotifications = function (disposalId) {
			const req = {
				method: "get",
				url: Vgr.constants.newHostUrl + Vgr.resources.apiV1.disposals + disposalId + "/notifications"
			};
			return $http(req);
		};

		const _listDisposalPendencyTypes = function () {
			return [
				{
					Id: Vgr.enumerations.destination.pendencyType.MTR,
					Description:
						$rootScope.labels.PENDENCIES_CONTROL_PENDENCY_DESCRIPTION[Vgr.enumerations.destination.pendencyType.MTR]
				},
				{
					Id: Vgr.enumerations.destination.pendencyType.CDF,
					Description:
						$rootScope.labels.PENDENCIES_CONTROL_PENDENCY_DESCRIPTION[Vgr.enumerations.destination.pendencyType.CDF]
				},
				{
					Id: Vgr.enumerations.destination.pendencyType.Invoice,
					Description:
						$rootScope.labels.PENDENCIES_CONTROL_PENDENCY_DESCRIPTION[Vgr.enumerations.destination.pendencyType.Invoice]
				}
			];
		};

		const _listDisposalTypes = function () {
			return Vgr.util.getWithCache(
				Vgr.constants.coreHostUrl + Vgr.resources.core.disposalTypes,
				null,
				disposalTypesCacheKey,
				cacheTimeoutInMinutes,
				localStorageWithTimeoutService,
				$http,
				$q
			);
		};

		const validationDtoHashDict = {};
		const _validateDisposal = function (dto) {
			const deferred = $q.defer();

			const dtoHash = objectHash(dto);
			if (validationDtoHashDict[dtoHash]) {
				deferred.resolve(validationDtoHashDict[dtoHash]);
				return deferred.promise;
			}

			const req = {
				method: "post",
				data: dto,
				url: Vgr.constants.newHostUrl + Vgr.resources.apiV1.default + "disposal-validations/"
			};

			const promise = $http(req);
			promise.then(function (response) {
				validationDtoHashDict[dtoHash] = response;
			});

			return promise;
		};

		function getErrorCode(errorMessage) {
			return errorMessage.Code ?? errorMessage.code;
		}

		function getErrorMessage(errorMessage) {
			return errorMessage.Message ?? errorMessage.message;
		}

		const _getIntegrationErrorMessageFromResponse = function (
			status,
			errors,
			systemDescription,
			includeDefaultMessage
		) {
			let defaultMessage = "";

			if (includeDefaultMessage) {
				defaultMessage = $rootScope.labels.MTR_SYSTEM_INTEGRATION_NOT_POSSIBLE;
			}

			if (errors && errors.length > 0) {
				const formattedErrorMessage = getFormattedErrorMessageFromErrors(
					defaultMessage,
					systemDescription,
					status,
					errors
				);
				if (formattedErrorMessage) {
					return formattedErrorMessage;
				}
			}

			return (
				defaultMessage + $rootScope.labels.DEFAULT_MTR_SYSTEM_ERROR_REASON.replace("[SYSTEM]", systemDescription || "")
			);
		};

		function getFormattedErrorMessageFromErrors(defaultMessage, systemDescription, status, errors) {
			const error = errors[0];
			const errorResponse = createResponseError(getErrorCode(error), getErrorMessage(error), status);

			if (errorResponse.isStatusBadRequest() && errorResponse.code && errorResponse.getErrorMessage()) {
				if (errorResponse.isErrorTemplate()) {
					return defaultMessage + errorResponse.getErrorMessage().replace("[SYSTEM]", systemDescription || "");
				} else {
					return defaultMessage + errorResponse.getErrorMessage();
				}
			}
		}

		function createResponseError(code, message, statusInternal) {
			return {
				code: code,
				message: message,
				status: statusInternal,
				getErrorMessage: function () {
					return $rootScope.labels[this.code] || this.message;
				},
				isErrorTemplate: function () {
					return (
						this.code === Vgr.errorCodes.disposal.SystemUnavailable ||
						this.code === Vgr.errorCodes.disposal.SystemInstable ||
						this.code === Vgr.errorCodes.disposal.SystemInstableOnCreation ||
						this.code === Vgr.errorCodes.disposal.WrongDestinatorType ||
						this.code === Vgr.errorCodes.disposal.WrongTransporterType
					);
				},
				isStatusBadRequest: function () {
					return this.status == Vgr.enumerations.httpErrorCode.BadRequest;
				}
			};
		}

		const _groupDisposalQuantitieByMeasureUnit = function (quantities) {
			return quantities.reduce((grouped, quantity) => {
				const measureUnitId = quantity.MeasureUnit.Id;
				grouped[measureUnitId] = grouped[measureUnitId] || [];
				grouped[measureUnitId].push(angular.copy(quantity));
				return grouped;
			}, []);
		};

		const _createDisposalManifest = function (disposalId, sourceIds) {
			const organizationId = accountService.getCurrentClient().organization.id;

			const req = {
				method: "post",
				data: { sourceIds: sourceIds },
				timeout: 240000,
				url:
					Vgr.constants.residuesManagementHostUrl +
					Vgr.resources.residuesManagement.createDisposalManifest
						.replace("[ORGANIZATION_ID]", organizationId)
						.replace("[DISPOSAL_ID]", disposalId)
			};
			return $http(req);
		};

		const _temporaryStoragerReceiveDisposal = function (dto) {
			const req = {
				method: "put",
				data: dto.model,
				url:
					Vgr.constants.newHostUrl +
					Vgr.resources.apiV2.temporaryStoragerReceiveDisposal
						.replace("[ORGANIZATION_UNIT]", dto.organizationUnitCode)
						.replace("[DISPOSAL]", dto.disposalId)
			};
			return $http(req);
		};

		return {
			groupDisposalQuantitieByMeasureUnit: _groupDisposalQuantitieByMeasureUnit,
			getDisposal: _getDisposal,
			createDisposal: _createDisposal,
			updateDisposal: _updateDisposal,

			listDisposalNotifications: _listDisposalNotifications,

			listDisposalPendencyTypes: _listDisposalPendencyTypes,
			listDisposalTypes: _listDisposalTypes,
			validateDisposal: _validateDisposal,
			getIntegrationErrorMessageFromResponse: _getIntegrationErrorMessageFromResponse,
			createDisposalManifest: _createDisposalManifest,
			temporaryStoragerReceiveDisposal: _temporaryStoragerReceiveDisposal
		};
	}
]);
